module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("Table of Contents")]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Page")])]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "#/c003"
    }
  }, [_vm._v("DEDICATION")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("H")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("From Bestselling Author | Kailin Gow | the phantom diaries")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now Available from | Bestselling Author Kailin Gow | dark memories (the phantom diaries, #2)")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Now Available from | Bestselling Author Kailin Gow | Wicked Woods")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Want to Know More about the PULSE Series, Author Insight, Author Appearance, Contests and Giveaways? | Join the PULSE Series Official Facebook Fan Page at:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Talk to Kailin Gow at:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Want More Edgy books like PULSE?")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "href": "#/c013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sparklesoup.com")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3bbc574","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/toc.vue
// module id = 63
// module chunks = 0